var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrid = function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#171D38",
    d: "M11.627 2.667h-6.6a2.36 2.36 0 0 0-2.36 2.36v6.6a2.36 2.36 0 0 0 2.36 2.36h6.6a2.36 2.36 0 0 0 2.36-2.36v-6.6a2.36 2.36 0 0 0-2.36-2.36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#171D38",
    d: "M26.973 2.667h-6.6a2.36 2.36 0 0 0-2.36 2.36v6.6a2.36 2.36 0 0 0 2.36 2.36h6.6a2.36 2.36 0 0 0 2.36-2.36v-6.6a2.36 2.36 0 0 0-2.36-2.36",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#171D38",
    d: "M26.96 18h-6.6A2.36 2.36 0 0 0 18 20.36v6.6a2.36 2.36 0 0 0 2.36 2.36h6.6a2.36 2.36 0 0 0 2.36-2.36v-6.6A2.36 2.36 0 0 0 26.96 18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#171D38",
    d: "M11.627 18h-6.6a2.36 2.36 0 0 0-2.36 2.36v6.6a2.36 2.36 0 0 0 2.36 2.36h6.6a2.36 2.36 0 0 0 2.36-2.36v-6.6a2.36 2.36 0 0 0-2.36-2.36",
    opacity: 0.3
  })));
};
export default SvgGrid;